import { useEffect } from "react";
import {
  derivePermissionDomains,
  identifyAuthenticatedUser,
} from "../analytics/sessionIdentity";
import { useAuthContext } from "./AuthContext";
import { useCachedTerreiro } from "../hooks/useCachedTerreiro";
import { useMyPermissionsDetailedQuery } from "../hooks/usePermissionQueries";

export const SessionAnalyticsSync = () => {
  const { user, isAuthenticated } = useAuthContext();
  const terreiro = useCachedTerreiro();
  const permissionsQuery = useMyPermissionsDetailedQuery({
    enabled: isAuthenticated && Boolean(terreiro?.id),
  });
  const detailed = permissionsQuery.data;
  const permissionsKnown = !terreiro?.id || permissionsQuery.isFetched;

  useEffect(() => {
    const userId =
      user && typeof user === "object" && "id" in user
        ? String((user as { id?: unknown }).id ?? "")
        : "";
    if (!userId) return;

    const roleSlugs = (detailed?.roles ?? [])
      .map((role: { slug?: string | null }) => role.slug ?? null)
      .filter((slug: string | null): slug is string => Boolean(slug));
    const permissionCodes = (detailed?.permissions ?? []).map(
      (permission: { code: string }) => permission.code,
    );

    const email =
      user && typeof user === "object" && "email" in user
        ? String((user as { email?: unknown }).email ?? "").trim() || undefined
        : undefined;
    const name =
      user && typeof user === "object" && "name" in user
        ? String((user as { name?: unknown }).name ?? "").trim() || undefined
        : undefined;

    identifyAuthenticatedUser(userId, {
      email,
      name,
      roleSlugs: permissionsKnown ? roleSlugs : undefined,
      permissionDomains: permissionsKnown
        ? derivePermissionDomains(permissionCodes)
        : undefined,
      activeProfileType: terreiro?.id ? "terreiro" : "personal",
      terreiroId: terreiro?.id ?? null,
    });
  }, [user, detailed, terreiro, permissionsKnown]);

  return null;
};
